import React from 'react';
import {
  useFetchRfqPartnersQuery,
  useAllowRfqDrawingFileDownloadMutation,
  CapaQuotationRfqAllowOpenFileStatus,
  CapaErrorCode,
  useFetchQuotationUserRfqDetailQuery
} from '@generated/graphql';
import { useSnackbar } from '@components/Provider';
import { CustomizedTypography } from '@components/Customized';
import DrawingFilesManagementPresenter from './DrawingFilePermissionSettingPresenter';

interface Props {
  matches?: boolean;
  rfqId?: string;
  isChat?: boolean;
}

const DrawingFilesManagementContainer: React.FC<Props> = ({
  matches,
  rfqId,
  isChat
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const { data } = useFetchQuotationUserRfqDetailQuery({
    variables: {
      rfqId: rfqId ?? ''
    },
    skip: !rfqId,
    fetchPolicy: 'cache-first'
  });

  const [
    allowRfqDrawingFileDownload
  ] = useAllowRfqDrawingFileDownloadMutation();

  const {
    data: rfqPartnersData,
    refetch: rfqPartnersRefetch
  } = useFetchRfqPartnersQuery({
    variables: { rfqId: rfqId! },
    skip: !rfqId
  });

  const onAllowRfqDrawingFileDownload = async (
    quotationPartnerId: string,
    permission: boolean,
    organizationName: string
  ) => {
    if (rfqId) {
      const resp = await allowRfqDrawingFileDownload({
        variables: {
          input: {
            rfqId: rfqId,
            quotationPartnerId: quotationPartnerId,
            status: permission
              ? CapaQuotationRfqAllowOpenFileStatus.Allow
              : CapaQuotationRfqAllowOpenFileStatus.Denied
          }
        }
      });
      if (
        resp &&
        resp.data &&
        resp.data.allowRfqDrawingFileDownload &&
        resp.data.allowRfqDrawingFileDownload.result === CapaErrorCode.Success
      ) {
        rfqPartnersRefetch();
        enqueueSnackbar(
          permission ? (
            <CustomizedTypography variant="subtitle2" color="inherit">
              {organizationName}에게
              <br />
              다운로드 권한이 부여되었습니다
            </CustomizedTypography>
          ) : (
            <CustomizedTypography variant="subtitle2" color="inherit">
              {organizationName}의<br />
              다운로드 권한을 제한하였습니다.
            </CustomizedTypography>
          ),
          {
            variant: 'success'
          }
        );
      }
    }
  };

  const rfqDetail = data?.fetchQuotationUserRfqDetail.data ?? undefined;

  return (
    <DrawingFilesManagementPresenter
      matches={matches}
      data={rfqDetail}
      isChat={isChat}
      rfqPartnersData={rfqPartnersData}
      onAllowRfqDrawingFileDownload={onAllowRfqDrawingFileDownload}
    />
  );
};

export default DrawingFilesManagementContainer;
